import { createWithEqualityFn as create } from 'zustand/traditional';
import { createToggler, ToggleAction } from './utils/toggler';

export interface DrawerStateValues {
  drawerOpen: boolean;
  showViewProducts: boolean;
  ariaHidden: boolean;
}

export interface DrawerStateActions {
  toggleDrawerOpen: ToggleAction;
  toggleShowViewProducts: ToggleAction;
  toggleAriaHidden: ToggleAction;
}

export interface DrawerState extends DrawerStateValues, DrawerStateActions {}

const defaultState: DrawerStateValues = {
  drawerOpen: false,
  showViewProducts: false,
  ariaHidden: true,
};

export const useDrawerState = create<DrawerState>()((set) => ({
  ...defaultState,
  toggleDrawerOpen: createToggler('drawerOpen', set, 'drawer/toggleDrawerOpen'),
  toggleShowViewProducts: createToggler('showViewProducts', set, 'drawer/toggleShowViewProducts'),
  toggleAriaHidden: createToggler('ariaHidden', set, 'drawer/toggleAriaHidden'),
}));
